module.exports = __webpack_public_path__ + "img/banking-and-financial-services.cbcd4149.svg";